import * as CONSTANTS from './constants';

export class MobileDropDownNav {
    constructor() {
        const dropDownParents = Array.prototype.slice.call(document.querySelectorAll('.drop-down-parent-js'));
        const headerNavPrimary = document.querySelector('.header-nav-primary') as HTMLElement;

        function setDropDownHeight(dropDownParent) {
            const headerNavPrimaryHeight = headerNavPrimary.scrollHeight;
            const dropDownCloseTriggerHeight = dropDownParent.querySelector('.drop-down-nav-mobile-toggle-close').scrollHeight;
            const dropDownListHeight = dropDownParent.querySelector('.drop-down-children-list').scrollHeight;

            const totalHeight = dropDownCloseTriggerHeight + dropDownListHeight + 50;

            if (totalHeight >= headerNavPrimaryHeight) {
                headerNavPrimary.style.height = totalHeight + 'px';
            } else {
                headerNavPrimary.style.height = 'auto';
            }
        }

        function openDropDown(dropDownOpenTrigger, dropDownParent) {
            dropDownOpenTrigger.classList.add('drop-down-nav-mobile-open');

            setDropDownHeight(dropDownParent);
        }

        function closeDropDown(dropDownOpenTrigger) {
            dropDownOpenTrigger.classList.remove('drop-down-nav-mobile-open');

            headerNavPrimary.style.height = 'auto';
        }

        if (dropDownParents != null) {
            dropDownParents.forEach(parent => {
                const dropDownOpenTrigger = parent.querySelector('.drop-down-nav-mobile-toggle-open');
                const dropDownCloseTrigger = parent.querySelector('.drop-down-nav-mobile-toggle-close');
                const listener = function() {
                    setDropDownHeight(parent);
                };

                if (dropDownOpenTrigger != null) {
                    dropDownOpenTrigger.addEventListener('click', () => {
                        openDropDown(dropDownOpenTrigger, parent);
                        window.addEventListener('resize', listener);

                        // Close drop down if resized to desktop
                        const mobileBreakpoint = `${CONSTANTS.MOBILE_BREAKPOINT + 0.1}rem`;

                        window.addEventListener('resize', () => {
                            if (window.matchMedia(`(min-width:${mobileBreakpoint})`).matches) {
                                closeDropDown(dropDownOpenTrigger);
                                window.removeEventListener('resize', listener);
                            }
                        });
                    });
                }

                if (dropDownCloseTrigger != null) {
                    dropDownCloseTrigger.addEventListener('click', () => {
                        closeDropDown(dropDownOpenTrigger);
                        window.removeEventListener('resize', listener);
                    });
                }
            });
        }
    }
}
